define('pages/main_page_model',['backbone', 'jquery', '_'], function (Backbone, $, _) {
  'use strict';
  var Model = Backbone.Model.extend({
    defaults: {
      siteName: 'K Diginäytöt',
      pageTitle: 'Ett cms',
      state: 'undefined',
      backUri: null,

      navigation: [
        {
          label: 'menu.home',
          uri: '/',
          route: 'home',
        },
        {
          label: 'menu.overview',
          uri: '/overview',
          route: 'overview',
        },
        {
          label: 'menu.weekly_offers',
          uri: '/campaigns',
          route: 'campaigns',
        },
        {
          label: 'menu.my_media',
          uri: '/media',
          route: 'media',
        },
        {
          label: 'menu.my_ads',
          uri: '/ads',
          route: 'bookings',
        },
        {
          label: 'menu.content_recommendations',
          uri: '/content_recommendations',
          route: 'content_recommendations',
        },
        {
          label: 'menu.settings',
          uri: '/settings',
          route: 'settings',
        },
        {
          label: 'menu.help',
          uri: '/help',
          route: 'help',
        },
        {
          label: 'menu.logout',
          uri: '/logout',
          route: 'logout',
        },
      ],
    },
  });
  return Model;
});

